import { useState, useCallback } from 'react';
import { DYNAMIC_REVIEWS_INITIAL_AMOUNT, DYNAMIC_REVIEWS_LOAD_PAGE_SIZE, ALL_REVIEWS_GET_KEY } from '../constants';
import { useAllReviewsQuery } from '../queries';

const pageSize = DYNAMIC_REVIEWS_LOAD_PAGE_SIZE;
const initiallyVisibleReviewsCount = DYNAMIC_REVIEWS_INITIAL_AMOUNT;

export function useInfiniteReviews() {
  const initialSize = Math.ceil((initiallyVisibleReviewsCount + pageSize) / pageSize);
  const [visibleCount, setVisibleCount] = useState(initiallyVisibleReviewsCount);

  const { reviews, areReviewsLoading, errorLoadingReviews, size, setSize } = useAllReviewsQuery({
    getKey: ALL_REVIEWS_GET_KEY,
    options: {
      initialSize,
      revalidateFirstPage: false,
      persistSize: true,
    },
  });

  const allReviews = reviews ? reviews.flat() : [];
  const visibleReviews = allReviews.slice(0, visibleCount);
  const hiddenLoadedReviewsCount = allReviews.length - visibleReviews.length;
  const hasMoreReviews = hiddenLoadedReviewsCount > 0;
  const isLastPage = hiddenLoadedReviewsCount < pageSize;

  const loadMore = useCallback(() => {
    if (!hasMoreReviews || areReviewsLoading) return;

    setVisibleCount((prev) => prev + pageSize);

    if (!isLastPage) {
      setSize(size + 1);
    }
  }, [hasMoreReviews, areReviewsLoading, setSize, size, isLastPage]);

  return {
    reviews: visibleReviews,
    isLoading: areReviewsLoading,
    hasMoreReviews,
    loadMore,
    error: errorLoadingReviews,
  };
}
